/**
 * Lookup table that maps each diacritic code point to its ASCII approximation.
 */
export const CODE_POINT_REPLACEMENTS: Map<number, string> = new Map<number, string>([
    [160 /* " " */, " "],
    [1984 /* "߀" */, "0"],
    [9424 /* "ⓐ" */, "a"],
    [65345 /* "ａ" */, "a"],
    [7834 /* "ẚ" */, "a"],
    [224 /* "à" */, "a"],
    [225 /* "á" */, "a"],
    [226 /* "â" */, "a"],
    [7847 /* "ầ" */, "a"],
    [7845 /* "ấ" */, "a"],
    [7851 /* "ẫ" */, "a"],
    [7849 /* "ẩ" */, "a"],
    [227 /* "ã" */, "a"],
    [257 /* "ā" */, "a"],
    [259 /* "ă" */, "a"],
    [7857 /* "ằ" */, "a"],
    [7855 /* "ắ" */, "a"],
    [7861 /* "ẵ" */, "a"],
    [7859 /* "ẳ" */, "a"],
    [551 /* "ȧ" */, "a"],
    [481 /* "ǡ" */, "a"],
    [228 /* "ä" */, "a"],
    [479 /* "ǟ" */, "a"],
    [7843 /* "ả" */, "a"],
    [229 /* "å" */, "a"],
    [507 /* "ǻ" */, "a"],
    [462 /* "ǎ" */, "a"],
    [513 /* "ȁ" */, "a"],
    [515 /* "ȃ" */, "a"],
    [7841 /* "ạ" */, "a"],
    [7853 /* "ậ" */, "a"],
    [7863 /* "ặ" */, "a"],
    [7681 /* "ḁ" */, "a"],
    [261 /* "ą" */, "a"],
    [11365 /* "ⱥ" */, "a"],
    [592 /* "ɐ" */, "a"],
    [593 /* "ɑ" */, "a"],
    [9398 /* "Ⓐ" */, "A"],
    [65313 /* "Ａ" */, "A"],
    [192 /* "À" */, "A"],
    [193 /* "Á" */, "A"],
    [194 /* "Â" */, "A"],
    [7846 /* "Ầ" */, "A"],
    [7844 /* "Ấ" */, "A"],
    [7850 /* "Ẫ" */, "A"],
    [7848 /* "Ẩ" */, "A"],
    [195 /* "Ã" */, "A"],
    [256 /* "Ā" */, "A"],
    [258 /* "Ă" */, "A"],
    [7856 /* "Ằ" */, "A"],
    [7854 /* "Ắ" */, "A"],
    [7860 /* "Ẵ" */, "A"],
    [7858 /* "Ẳ" */, "A"],
    [550 /* "Ȧ" */, "A"],
    [480 /* "Ǡ" */, "A"],
    [196 /* "Ä" */, "A"],
    [478 /* "Ǟ" */, "A"],
    [7842 /* "Ả" */, "A"],
    [197 /* "Å" */, "A"],
    [506 /* "Ǻ" */, "A"],
    [461 /* "Ǎ" */, "A"],
    [512 /* "Ȁ" */, "A"],
    [514 /* "Ȃ" */, "A"],
    [7840 /* "Ạ" */, "A"],
    [7852 /* "Ậ" */, "A"],
    [7862 /* "Ặ" */, "A"],
    [7680 /* "Ḁ" */, "A"],
    [260 /* "Ą" */, "A"],
    [570 /* "Ⱥ" */, "A"],
    [11375 /* "Ɐ" */, "A"],
    [42803 /* "ꜳ" */, "aa"],
    [42802 /* "Ꜳ" */, "AA"],
    [230 /* "æ" */, "ae"],
    [509 /* "ǽ" */, "ae"],
    [483 /* "ǣ" */, "ae"],
    [198 /* "Æ" */, "AE"],
    [508 /* "Ǽ" */, "AE"],
    [482 /* "Ǣ" */, "AE"],
    [42805 /* "ꜵ" */, "ao"],
    [42804 /* "Ꜵ" */, "AO"],
    [42807 /* "ꜷ" */, "au"],
    [42806 /* "Ꜷ" */, "AU"],
    [42809 /* "ꜹ" */, "av"],
    [42811 /* "ꜻ" */, "av"],
    [42808 /* "Ꜹ" */, "AV"],
    [42810 /* "Ꜻ" */, "AV"],
    [42813 /* "ꜽ" */, "ay"],
    [42812 /* "Ꜽ" */, "AY"],
    [9425 /* "ⓑ" */, "b"],
    [65346 /* "ｂ" */, "b"],
    [7683 /* "ḃ" */, "b"],
    [7685 /* "ḅ" */, "b"],
    [7687 /* "ḇ" */, "b"],
    [384 /* "ƀ" */, "b"],
    [387 /* "ƃ" */, "b"],
    [595 /* "ɓ" */, "b"],
    [386 /* "Ƃ" */, "b"],
    [9399 /* "Ⓑ" */, "B"],
    [65314 /* "Ｂ" */, "B"],
    [7682 /* "Ḃ" */, "B"],
    [7684 /* "Ḅ" */, "B"],
    [7686 /* "Ḇ" */, "B"],
    [579 /* "Ƀ" */, "B"],
    [385 /* "Ɓ" */, "B"],
    [65347 /* "ｃ" */, "c"],
    [9426 /* "ⓒ" */, "c"],
    [263 /* "ć" */, "c"],
    [265 /* "ĉ" */, "c"],
    [267 /* "ċ" */, "c"],
    [269 /* "č" */, "c"],
    [231 /* "ç" */, "c"],
    [7689 /* "ḉ" */, "c"],
    [392 /* "ƈ" */, "c"],
    [572 /* "ȼ" */, "c"],
    [42815 /* "ꜿ" */, "c"],
    [8580 /* "ↄ" */, "c"],
    [9400 /* "Ⓒ" */, "C"],
    [65315 /* "Ｃ" */, "C"],
    [42814 /* "Ꜿ" */, "C"],
    [7688 /* "Ḉ" */, "C"],
    [262 /* "Ć" */, "C"],
    [67 /* "C" */, "C"],
    [264 /* "Ĉ" */, "C"],
    [266 /* "Ċ" */, "C"],
    [268 /* "Č" */, "C"],
    [199 /* "Ç" */, "C"],
    [391 /* "Ƈ" */, "C"],
    [571 /* "Ȼ" */, "C"],
    [9427 /* "ⓓ" */, "d"],
    [65348 /* "ｄ" */, "d"],
    [7691 /* "ḋ" */, "d"],
    [271 /* "ď" */, "d"],
    [7693 /* "ḍ" */, "d"],
    [7697 /* "ḑ" */, "d"],
    [7699 /* "ḓ" */, "d"],
    [7695 /* "ḏ" */, "d"],
    [273 /* "đ" */, "d"],
    [396 /* "ƌ" */, "d"],
    [598 /* "ɖ" */, "d"],
    [599 /* "ɗ" */, "d"],
    [395 /* "Ƌ" */, "d"],
    [5095 /* "Ꮷ" */, "d"],
    [1281 /* "ԁ" */, "d"],
    [42922 /* "Ɦ" */, "d"],
    [9401 /* "Ⓓ" */, "D"],
    [65316 /* "Ｄ" */, "D"],
    [7690 /* "Ḋ" */, "D"],
    [270 /* "Ď" */, "D"],
    [7692 /* "Ḍ" */, "D"],
    [7696 /* "Ḑ" */, "D"],
    [7698 /* "Ḓ" */, "D"],
    [7694 /* "Ḏ" */, "D"],
    [272 /* "Đ" */, "D"],
    [394 /* "Ɗ" */, "D"],
    [393 /* "Ɖ" */, "D"],
    [7429 /* "ᴅ" */, "D"],
    [42873 /* "Ꝺ" */, "D"],
    [240 /* "ð" */, "dh"],
    [208 /* "Ð" */, "Dh"],
    [499 /* "ǳ" */, "dz"],
    [454 /* "ǆ" */, "dz"],
    [498 /* "ǲ" */, "Dz"],
    [453 /* "ǅ" */, "Dz"],
    [497 /* "Ǳ" */, "DZ"],
    [452 /* "Ǆ" */, "DZ"],
    [9428 /* "ⓔ" */, "e"],
    [65349 /* "ｅ" */, "e"],
    [232 /* "è" */, "e"],
    [233 /* "é" */, "e"],
    [234 /* "ê" */, "e"],
    [7873 /* "ề" */, "e"],
    [7871 /* "ế" */, "e"],
    [7877 /* "ễ" */, "e"],
    [7875 /* "ể" */, "e"],
    [7869 /* "ẽ" */, "e"],
    [275 /* "ē" */, "e"],
    [7701 /* "ḕ" */, "e"],
    [7703 /* "ḗ" */, "e"],
    [277 /* "ĕ" */, "e"],
    [279 /* "ė" */, "e"],
    [235 /* "ë" */, "e"],
    [7867 /* "ẻ" */, "e"],
    [283 /* "ě" */, "e"],
    [517 /* "ȅ" */, "e"],
    [519 /* "ȇ" */, "e"],
    [7865 /* "ẹ" */, "e"],
    [7879 /* "ệ" */, "e"],
    [553 /* "ȩ" */, "e"],
    [7709 /* "ḝ" */, "e"],
    [281 /* "ę" */, "e"],
    [7705 /* "ḙ" */, "e"],
    [7707 /* "ḛ" */, "e"],
    [583 /* "ɇ" */, "e"],
    [477 /* "ǝ" */, "e"],
    [603 /* "ɛ" */, "E"],
    [9402 /* "Ⓔ" */, "E"],
    [65317 /* "Ｅ" */, "E"],
    [200 /* "È" */, "E"],
    [201 /* "É" */, "E"],
    [202 /* "Ê" */, "E"],
    [7872 /* "Ề" */, "E"],
    [7870 /* "Ế" */, "E"],
    [7876 /* "Ễ" */, "E"],
    [7874 /* "Ể" */, "E"],
    [7868 /* "Ẽ" */, "E"],
    [274 /* "Ē" */, "E"],
    [7700 /* "Ḕ" */, "E"],
    [7702 /* "Ḗ" */, "E"],
    [276 /* "Ĕ" */, "E"],
    [278 /* "Ė" */, "E"],
    [203 /* "Ë" */, "E"],
    [7866 /* "Ẻ" */, "E"],
    [282 /* "Ě" */, "E"],
    [516 /* "Ȅ" */, "E"],
    [518 /* "Ȇ" */, "E"],
    [7864 /* "Ẹ" */, "E"],
    [7878 /* "Ệ" */, "E"],
    [552 /* "Ȩ" */, "E"],
    [7708 /* "Ḝ" */, "E"],
    [280 /* "Ę" */, "E"],
    [7704 /* "Ḙ" */, "E"],
    [7706 /* "Ḛ" */, "E"],
    [400 /* "Ɛ" */, "E"],
    [398 /* "Ǝ" */, "E"],
    [7431 /* "ᴇ" */, "E"],
    [9429 /* "ⓕ" */, "f"],
    [65350 /* "ｆ" */, "f"],
    [7711 /* "ḟ" */, "f"],
    [402 /* "ƒ" */, "f"],
    [42876 /* "ꝼ" */, "F"],
    [9403 /* "Ⓕ" */, "F"],
    [65318 /* "Ｆ" */, "F"],
    [7710 /* "Ḟ" */, "F"],
    [401 /* "Ƒ" */, "F"],
    [42875 /* "Ꝼ" */, "F"],
    [64256 /* "ﬀ" */, "ff"],
    [64259 /* "ﬃ" */, "ffi"],
    [64260 /* "ﬄ" */, "ffl"],
    [64257 /* "ﬁ" */, "fi"],
    [64258 /* "ﬂ" */, "fl"],
    [9430 /* "ⓖ" */, "g"],
    [65351 /* "ｇ" */, "g"],
    [501 /* "ǵ" */, "g"],
    [285 /* "ĝ" */, "g"],
    [7713 /* "ḡ" */, "g"],
    [287 /* "ğ" */, "g"],
    [289 /* "ġ" */, "g"],
    [487 /* "ǧ" */, "g"],
    [291 /* "ģ" */, "g"],
    [485 /* "ǥ" */, "g"],
    [608 /* "ɠ" */, "g"],
    [42913 /* "ꞡ" */, "g"],
    [42879 /* "ꝿ" */, "g"],
    [7545 /* "ᵹ" */, "g"],
    [9404 /* "Ⓖ" */, "G"],
    [65319 /* "Ｇ" */, "G"],
    [500 /* "Ǵ" */, "G"],
    [284 /* "Ĝ" */, "G"],
    [7712 /* "Ḡ" */, "G"],
    [286 /* "Ğ" */, "G"],
    [288 /* "Ġ" */, "G"],
    [486 /* "Ǧ" */, "G"],
    [290 /* "Ģ" */, "G"],
    [484 /* "Ǥ" */, "G"],
    [403 /* "Ɠ" */, "G"],
    [42912 /* "Ꞡ" */, "G"],
    [42877 /* "Ᵹ" */, "G"],
    [42878 /* "Ꝿ" */, "G"],
    [610 /* "ɢ" */, "G"],
    [9431 /* "ⓗ" */, "h"],
    [65352 /* "ｈ" */, "h"],
    [293 /* "ĥ" */, "h"],
    [7715 /* "ḣ" */, "h"],
    [7719 /* "ḧ" */, "h"],
    [543 /* "ȟ" */, "h"],
    [7717 /* "ḥ" */, "h"],
    [7721 /* "ḩ" */, "h"],
    [7723 /* "ḫ" */, "h"],
    [7830 /* "ẖ" */, "h"],
    [295 /* "ħ" */, "h"],
    [11368 /* "ⱨ" */, "h"],
    [11382 /* "ⱶ" */, "h"],
    [613 /* "ɥ" */, "h"],
    [9405 /* "Ⓗ" */, "H"],
    [65320 /* "Ｈ" */, "H"],
    [292 /* "Ĥ" */, "H"],
    [7714 /* "Ḣ" */, "H"],
    [7718 /* "Ḧ" */, "H"],
    [542 /* "Ȟ" */, "H"],
    [7716 /* "Ḥ" */, "H"],
    [7720 /* "Ḩ" */, "H"],
    [7722 /* "Ḫ" */, "H"],
    [294 /* "Ħ" */, "H"],
    [11367 /* "Ⱨ" */, "H"],
    [11381 /* "Ⱶ" */, "H"],
    [42893 /* "Ɥ" */, "H"],
    [405 /* "ƕ" */, "hv"],
    [9432 /* "ⓘ" */, "i"],
    [65353 /* "ｉ" */, "i"],
    [236 /* "ì" */, "i"],
    [237 /* "í" */, "i"],
    [238 /* "î" */, "i"],
    [297 /* "ĩ" */, "i"],
    [299 /* "ī" */, "i"],
    [301 /* "ĭ" */, "i"],
    [239 /* "ï" */, "i"],
    [7727 /* "ḯ" */, "i"],
    [7881 /* "ỉ" */, "i"],
    [464 /* "ǐ" */, "i"],
    [521 /* "ȉ" */, "i"],
    [523 /* "ȋ" */, "i"],
    [7883 /* "ị" */, "i"],
    [303 /* "į" */, "i"],
    [7725 /* "ḭ" */, "i"],
    [616 /* "ɨ" */, "i"],
    [305 /* "ı" */, "i"],
    [9406 /* "Ⓘ" */, "I"],
    [65321 /* "Ｉ" */, "I"],
    [204 /* "Ì" */, "I"],
    [205 /* "Í" */, "I"],
    [206 /* "Î" */, "I"],
    [296 /* "Ĩ" */, "I"],
    [298 /* "Ī" */, "I"],
    [300 /* "Ĭ" */, "I"],
    [304 /* "İ" */, "I"],
    [207 /* "Ï" */, "I"],
    [7726 /* "Ḯ" */, "I"],
    [7880 /* "Ỉ" */, "I"],
    [463 /* "Ǐ" */, "I"],
    [520 /* "Ȉ" */, "I"],
    [522 /* "Ȋ" */, "I"],
    [7882 /* "Ị" */, "I"],
    [302 /* "Į" */, "I"],
    [7724 /* "Ḭ" */, "I"],
    [407 /* "Ɨ" */, "I"],
    [9433 /* "ⓙ" */, "j"],
    [65354 /* "ｊ" */, "j"],
    [309 /* "ĵ" */, "j"],
    [496 /* "ǰ" */, "j"],
    [585 /* "ɉ" */, "j"],
    [9407 /* "Ⓙ" */, "J"],
    [65322 /* "Ｊ" */, "J"],
    [308 /* "Ĵ" */, "J"],
    [584 /* "Ɉ" */, "J"],
    [567 /* "ȷ" */, "J"],
    [9434 /* "ⓚ" */, "k"],
    [65355 /* "ｋ" */, "k"],
    [7729 /* "ḱ" */, "k"],
    [489 /* "ǩ" */, "k"],
    [7731 /* "ḳ" */, "k"],
    [311 /* "ķ" */, "k"],
    [7733 /* "ḵ" */, "k"],
    [409 /* "ƙ" */, "k"],
    [11370 /* "ⱪ" */, "k"],
    [42817 /* "ꝁ" */, "k"],
    [42819 /* "ꝃ" */, "k"],
    [42821 /* "ꝅ" */, "k"],
    [42915 /* "ꞣ" */, "k"],
    [9408 /* "Ⓚ" */, "K"],
    [65323 /* "Ｋ" */, "K"],
    [7728 /* "Ḱ" */, "K"],
    [488 /* "Ǩ" */, "K"],
    [7730 /* "Ḳ" */, "K"],
    [310 /* "Ķ" */, "K"],
    [7732 /* "Ḵ" */, "K"],
    [408 /* "Ƙ" */, "K"],
    [11369 /* "Ⱪ" */, "K"],
    [42816 /* "Ꝁ" */, "K"],
    [42818 /* "Ꝃ" */, "K"],
    [42820 /* "Ꝅ" */, "K"],
    [42914 /* "Ꞣ" */, "K"],
    [9435 /* "ⓛ" */, "l"],
    [65356 /* "ｌ" */, "l"],
    [320 /* "ŀ" */, "l"],
    [314 /* "ĺ" */, "l"],
    [318 /* "ľ" */, "l"],
    [7735 /* "ḷ" */, "l"],
    [7737 /* "ḹ" */, "l"],
    [316 /* "ļ" */, "l"],
    [7741 /* "ḽ" */, "l"],
    [7739 /* "ḻ" */, "l"],
    [383 /* "ſ" */, "l"],
    [322 /* "ł" */, "l"],
    [410 /* "ƚ" */, "l"],
    [619 /* "ɫ" */, "l"],
    [11361 /* "ⱡ" */, "l"],
    [42825 /* "ꝉ" */, "l"],
    [42881 /* "ꞁ" */, "l"],
    [42823 /* "ꝇ" */, "l"],
    [621 /* "ɭ" */, "l"],
    [9409 /* "Ⓛ" */, "L"],
    [65324 /* "Ｌ" */, "L"],
    [319 /* "Ŀ" */, "L"],
    [313 /* "Ĺ" */, "L"],
    [317 /* "Ľ" */, "L"],
    [7734 /* "Ḷ" */, "L"],
    [7736 /* "Ḹ" */, "L"],
    [315 /* "Ļ" */, "L"],
    [7740 /* "Ḽ" */, "L"],
    [7738 /* "Ḻ" */, "L"],
    [321 /* "Ł" */, "L"],
    [573 /* "Ƚ" */, "L"],
    [11362 /* "Ɫ" */, "L"],
    [11360 /* "Ⱡ" */, "L"],
    [42824 /* "Ꝉ" */, "L"],
    [42822 /* "Ꝇ" */, "L"],
    [42880 /* "Ꞁ" */, "L"],
    [457 /* "ǉ" */, "lj"],
    [456 /* "ǈ" */, "Lj"],
    [455 /* "Ǉ" */, "LJ"],
    [9436 /* "ⓜ" */, "m"],
    [65357 /* "ｍ" */, "m"],
    [7743 /* "ḿ" */, "m"],
    [7745 /* "ṁ" */, "m"],
    [7747 /* "ṃ" */, "m"],
    [625 /* "ɱ" */, "m"],
    [623 /* "ɯ" */, "m"],
    [9410 /* "Ⓜ" */, "M"],
    [65325 /* "Ｍ" */, "M"],
    [7742 /* "Ḿ" */, "M"],
    [7744 /* "Ṁ" */, "M"],
    [7746 /* "Ṃ" */, "M"],
    [11374 /* "Ɱ" */, "M"],
    [412 /* "Ɯ" */, "M"],
    [1019 /* "ϻ" */, "M"],
    [9437 /* "ⓝ" */, "n"],
    [65358 /* "ｎ" */, "n"],
    [505 /* "ǹ" */, "n"],
    [324 /* "ń" */, "n"],
    [241 /* "ñ" */, "n"],
    [7749 /* "ṅ" */, "n"],
    [328 /* "ň" */, "n"],
    [7751 /* "ṇ" */, "n"],
    [326 /* "ņ" */, "n"],
    [7755 /* "ṋ" */, "n"],
    [7753 /* "ṉ" */, "n"],
    [414 /* "ƞ" */, "n"],
    [626 /* "ɲ" */, "n"],
    [329 /* "ŉ" */, "n"],
    [42897 /* "ꞑ" */, "n"],
    [42917 /* "ꞥ" */, "n"],
    [1083 /* "л" */, "n"],
    [1289 /* "ԉ" */, "n"],
    [42916 /* "Ꞥ" */, "N"],
    [544 /* "Ƞ" */, "N"],
    [9411 /* "Ⓝ" */, "N"],
    [65326 /* "Ｎ" */, "N"],
    [504 /* "Ǹ" */, "N"],
    [323 /* "Ń" */, "N"],
    [209 /* "Ñ" */, "N"],
    [7748 /* "Ṅ" */, "N"],
    [327 /* "Ň" */, "N"],
    [7750 /* "Ṇ" */, "N"],
    [325 /* "Ņ" */, "N"],
    [7754 /* "Ṋ" */, "N"],
    [7752 /* "Ṉ" */, "N"],
    [413 /* "Ɲ" */, "N"],
    [42896 /* "Ꞑ" */, "N"],
    [7438 /* "ᴎ" */, "N"],
    [460 /* "ǌ" */, "nj"],
    [459 /* "ǋ" */, "Nj"],
    [458 /* "Ǌ" */, "NJ"],
    [9438 /* "ⓞ" */, "o"],
    [65359 /* "ｏ" */, "o"],
    [1086 /* "о" */, "o"],
    [242 /* "ò" */, "o"],
    [243 /* "ó" */, "o"],
    [244 /* "ô" */, "o"],
    [7891 /* "ồ" */, "o"],
    [7889 /* "ố" */, "o"],
    [7895 /* "ỗ" */, "o"],
    [7893 /* "ổ" */, "o"],
    [245 /* "õ" */, "o"],
    [7757 /* "ṍ" */, "o"],
    [557 /* "ȭ" */, "o"],
    [7759 /* "ṏ" */, "o"],
    [333 /* "ō" */, "o"],
    [7761 /* "ṑ" */, "o"],
    [7763 /* "ṓ" */, "o"],
    [335 /* "ŏ" */, "o"],
    [559 /* "ȯ" */, "o"],
    [561 /* "ȱ" */, "o"],
    [246 /* "ö" */, "o"],
    [555 /* "ȫ" */, "o"],
    [7887 /* "ỏ" */, "o"],
    [337 /* "ő" */, "o"],
    [466 /* "ǒ" */, "o"],
    [525 /* "ȍ" */, "o"],
    [527 /* "ȏ" */, "o"],
    [417 /* "ơ" */, "o"],
    [7901 /* "ờ" */, "o"],
    [7899 /* "ớ" */, "o"],
    [7905 /* "ỡ" */, "o"],
    [7903 /* "ở" */, "o"],
    [7907 /* "ợ" */, "o"],
    [7885 /* "ọ" */, "o"],
    [7897 /* "ộ" */, "o"],
    [491 /* "ǫ" */, "o"],
    [493 /* "ǭ" */, "o"],
    [248 /* "ø" */, "o"],
    [511 /* "ǿ" */, "o"],
    [42827 /* "ꝋ" */, "o"],
    [42829 /* "ꝍ" */, "o"],
    [629 /* "ɵ" */, "o"],
    [596 /* "ɔ" */, "o"],
    [7441 /* "ᴑ" */, "o"],
    [9412 /* "Ⓞ" */, "O"],
    [65327 /* "Ｏ" */, "O"],
    [210 /* "Ò" */, "O"],
    [211 /* "Ó" */, "O"],
    [212 /* "Ô" */, "O"],
    [7890 /* "Ồ" */, "O"],
    [7888 /* "Ố" */, "O"],
    [7894 /* "Ỗ" */, "O"],
    [7892 /* "Ổ" */, "O"],
    [213 /* "Õ" */, "O"],
    [7756 /* "Ṍ" */, "O"],
    [556 /* "Ȭ" */, "O"],
    [7758 /* "Ṏ" */, "O"],
    [332 /* "Ō" */, "O"],
    [7760 /* "Ṑ" */, "O"],
    [7762 /* "Ṓ" */, "O"],
    [334 /* "Ŏ" */, "O"],
    [558 /* "Ȯ" */, "O"],
    [560 /* "Ȱ" */, "O"],
    [214 /* "Ö" */, "O"],
    [554 /* "Ȫ" */, "O"],
    [7886 /* "Ỏ" */, "O"],
    [336 /* "Ő" */, "O"],
    [465 /* "Ǒ" */, "O"],
    [524 /* "Ȍ" */, "O"],
    [526 /* "Ȏ" */, "O"],
    [416 /* "Ơ" */, "O"],
    [7900 /* "Ờ" */, "O"],
    [7898 /* "Ớ" */, "O"],
    [7904 /* "Ỡ" */, "O"],
    [7902 /* "Ở" */, "O"],
    [7906 /* "Ợ" */, "O"],
    [7884 /* "Ọ" */, "O"],
    [7896 /* "Ộ" */, "O"],
    [490 /* "Ǫ" */, "O"],
    [492 /* "Ǭ" */, "O"],
    [216 /* "Ø" */, "O"],
    [510 /* "Ǿ" */, "O"],
    [390 /* "Ɔ" */, "O"],
    [415 /* "Ɵ" */, "O"],
    [42826 /* "Ꝋ" */, "O"],
    [42828 /* "Ꝍ" */, "O"],
    [339 /* "œ" */, "oe"],
    [338 /* "Œ" */, "OE"],
    [419 /* "ƣ" */, "oi"],
    [418 /* "Ƣ" */, "OI"],
    [42831 /* "ꝏ" */, "oo"],
    [42830 /* "Ꝏ" */, "OO"],
    [547 /* "ȣ" */, "ou"],
    [546 /* "Ȣ" */, "OU"],
    [9439 /* "ⓟ" */, "p"],
    [65360 /* "ｐ" */, "p"],
    [7765 /* "ṕ" */, "p"],
    [7767 /* "ṗ" */, "p"],
    [421 /* "ƥ" */, "p"],
    [7549 /* "ᵽ" */, "p"],
    [42833 /* "ꝑ" */, "p"],
    [42835 /* "ꝓ" */, "p"],
    [42837 /* "ꝕ" */, "p"],
    [961 /* "ρ" */, "p"],
    [9413 /* "Ⓟ" */, "P"],
    [65328 /* "Ｐ" */, "P"],
    [7764 /* "Ṕ" */, "P"],
    [7766 /* "Ṗ" */, "P"],
    [420 /* "Ƥ" */, "P"],
    [11363 /* "Ᵽ" */, "P"],
    [42832 /* "Ꝑ" */, "P"],
    [42834 /* "Ꝓ" */, "P"],
    [42836 /* "Ꝕ" */, "P"],
    [9440 /* "ⓠ" */, "q"],
    [65361 /* "ｑ" */, "q"],
    [587 /* "ɋ" */, "q"],
    [42839 /* "ꝗ" */, "q"],
    [42841 /* "ꝙ" */, "q"],
    [9414 /* "Ⓠ" */, "Q"],
    [65329 /* "Ｑ" */, "Q"],
    [42838 /* "Ꝗ" */, "Q"],
    [42840 /* "Ꝙ" */, "Q"],
    [586 /* "Ɋ" */, "Q"],
    [9441 /* "ⓡ" */, "r"],
    [65362 /* "ｒ" */, "r"],
    [341 /* "ŕ" */, "r"],
    [7769 /* "ṙ" */, "r"],
    [345 /* "ř" */, "r"],
    [529 /* "ȑ" */, "r"],
    [531 /* "ȓ" */, "r"],
    [7771 /* "ṛ" */, "r"],
    [7773 /* "ṝ" */, "r"],
    [343 /* "ŗ" */, "r"],
    [7775 /* "ṟ" */, "r"],
    [589 /* "ɍ" */, "r"],
    [637 /* "ɽ" */, "r"],
    [42843 /* "ꝛ" */, "r"],
    [42919 /* "ꞧ" */, "r"],
    [42883 /* "ꞃ" */, "r"],
    [9415 /* "Ⓡ" */, "R"],
    [65330 /* "Ｒ" */, "R"],
    [340 /* "Ŕ" */, "R"],
    [7768 /* "Ṙ" */, "R"],
    [344 /* "Ř" */, "R"],
    [528 /* "Ȑ" */, "R"],
    [530 /* "Ȓ" */, "R"],
    [7770 /* "Ṛ" */, "R"],
    [7772 /* "Ṝ" */, "R"],
    [342 /* "Ŗ" */, "R"],
    [7774 /* "Ṟ" */, "R"],
    [588 /* "Ɍ" */, "R"],
    [11364 /* "Ɽ" */, "R"],
    [42842 /* "Ꝛ" */, "R"],
    [42918 /* "Ꞧ" */, "R"],
    [42882 /* "Ꞃ" */, "R"],
    [9442 /* "ⓢ" */, "s"],
    [65363 /* "ｓ" */, "s"],
    [347 /* "ś" */, "s"],
    [7781 /* "ṥ" */, "s"],
    [349 /* "ŝ" */, "s"],
    [7777 /* "ṡ" */, "s"],
    [353 /* "š" */, "s"],
    [7783 /* "ṧ" */, "s"],
    [7779 /* "ṣ" */, "s"],
    [7785 /* "ṩ" */, "s"],
    [537 /* "ș" */, "s"],
    [351 /* "ş" */, "s"],
    [575 /* "ȿ" */, "s"],
    [42921 /* "ꞩ" */, "s"],
    [42885 /* "ꞅ" */, "s"],
    [7835 /* "ẛ" */, "s"],
    [642 /* "ʂ" */, "s"],
    [9416 /* "Ⓢ" */, "S"],
    [65331 /* "Ｓ" */, "S"],
    [7838 /* "ẞ" */, "S"],
    [346 /* "Ś" */, "S"],
    [7780 /* "Ṥ" */, "S"],
    [348 /* "Ŝ" */, "S"],
    [7776 /* "Ṡ" */, "S"],
    [352 /* "Š" */, "S"],
    [7782 /* "Ṧ" */, "S"],
    [7778 /* "Ṣ" */, "S"],
    [7784 /* "Ṩ" */, "S"],
    [536 /* "Ș" */, "S"],
    [350 /* "Ş" */, "S"],
    [11390 /* "Ȿ" */, "S"],
    [42920 /* "Ꞩ" */, "S"],
    [42884 /* "Ꞅ" */, "S"],
    [223 /* "ß" */, "ss"],
    [9443 /* "ⓣ" */, "t"],
    [65364 /* "ｔ" */, "t"],
    [1090 /* "т" */, "t"],
    [7787 /* "ṫ" */, "t"],
    [7831 /* "ẗ" */, "t"],
    [357 /* "ť" */, "t"],
    [7789 /* "ṭ" */, "t"],
    [539 /* "ț" */, "t"],
    [355 /* "ţ" */, "t"],
    [7793 /* "ṱ" */, "t"],
    [7791 /* "ṯ" */, "t"],
    [359 /* "ŧ" */, "t"],
    [429 /* "ƭ" */, "t"],
    [648 /* "ʈ" */, "t"],
    [11366 /* "ⱦ" */, "t"],
    [42887 /* "ꞇ" */, "t"],
    [9417 /* "Ⓣ" */, "T"],
    [65332 /* "Ｔ" */, "T"],
    [7786 /* "Ṫ" */, "T"],
    [356 /* "Ť" */, "T"],
    [7788 /* "Ṭ" */, "T"],
    [538 /* "Ț" */, "T"],
    [354 /* "Ţ" */, "T"],
    [7792 /* "Ṱ" */, "T"],
    [7790 /* "Ṯ" */, "T"],
    [358 /* "Ŧ" */, "T"],
    [428 /* "Ƭ" */, "T"],
    [430 /* "Ʈ" */, "T"],
    [574 /* "Ⱦ" */, "T"],
    [42886 /* "Ꞇ" */, "T"],
    [254 /* "þ" */, "th"],
    [222 /* "Þ" */, "Th"],
    [42793 /* "ꜩ" */, "tz"],
    [42792 /* "Ꜩ" */, "TZ"],
    [9444 /* "ⓤ" */, "u"],
    [65365 /* "ｕ" */, "u"],
    [249 /* "ù" */, "u"],
    [250 /* "ú" */, "u"],
    [251 /* "û" */, "u"],
    [361 /* "ũ" */, "u"],
    [7801 /* "ṹ" */, "u"],
    [363 /* "ū" */, "u"],
    [7803 /* "ṻ" */, "u"],
    [365 /* "ŭ" */, "u"],
    [252 /* "ü" */, "u"],
    [476 /* "ǜ" */, "u"],
    [472 /* "ǘ" */, "u"],
    [470 /* "ǖ" */, "u"],
    [474 /* "ǚ" */, "u"],
    [7911 /* "ủ" */, "u"],
    [367 /* "ů" */, "u"],
    [369 /* "ű" */, "u"],
    [468 /* "ǔ" */, "u"],
    [533 /* "ȕ" */, "u"],
    [535 /* "ȗ" */, "u"],
    [432 /* "ư" */, "u"],
    [7915 /* "ừ" */, "u"],
    [7913 /* "ứ" */, "u"],
    [7919 /* "ữ" */, "u"],
    [7917 /* "ử" */, "u"],
    [7921 /* "ự" */, "u"],
    [7909 /* "ụ" */, "u"],
    [7795 /* "ṳ" */, "u"],
    [371 /* "ų" */, "u"],
    [7799 /* "ṷ" */, "u"],
    [7797 /* "ṵ" */, "u"],
    [649 /* "ʉ" */, "u"],
    [9418 /* "Ⓤ" */, "U"],
    [65333 /* "Ｕ" */, "U"],
    [217 /* "Ù" */, "U"],
    [218 /* "Ú" */, "U"],
    [219 /* "Û" */, "U"],
    [360 /* "Ũ" */, "U"],
    [7800 /* "Ṹ" */, "U"],
    [362 /* "Ū" */, "U"],
    [7802 /* "Ṻ" */, "U"],
    [364 /* "Ŭ" */, "U"],
    [220 /* "Ü" */, "U"],
    [475 /* "Ǜ" */, "U"],
    [471 /* "Ǘ" */, "U"],
    [469 /* "Ǖ" */, "U"],
    [473 /* "Ǚ" */, "U"],
    [7910 /* "Ủ" */, "U"],
    [366 /* "Ů" */, "U"],
    [368 /* "Ű" */, "U"],
    [467 /* "Ǔ" */, "U"],
    [532 /* "Ȕ" */, "U"],
    [534 /* "Ȗ" */, "U"],
    [431 /* "Ư" */, "U"],
    [7914 /* "Ừ" */, "U"],
    [7912 /* "Ứ" */, "U"],
    [7918 /* "Ữ" */, "U"],
    [7916 /* "Ử" */, "U"],
    [7920 /* "Ự" */, "U"],
    [7908 /* "Ụ" */, "U"],
    [7794 /* "Ṳ" */, "U"],
    [370 /* "Ų" */, "U"],
    [7798 /* "Ṷ" */, "U"],
    [7796 /* "Ṵ" */, "U"],
    [580 /* "Ʉ" */, "U"],
    [9445 /* "ⓥ" */, "v"],
    [65366 /* "ｖ" */, "v"],
    [7805 /* "ṽ" */, "v"],
    [7807 /* "ṿ" */, "v"],
    [651 /* "ʋ" */, "v"],
    [42847 /* "ꝟ" */, "v"],
    [652 /* "ʌ" */, "v"],
    [9419 /* "Ⓥ" */, "V"],
    [65334 /* "Ｖ" */, "V"],
    [7804 /* "Ṽ" */, "V"],
    [7806 /* "Ṿ" */, "V"],
    [434 /* "Ʋ" */, "V"],
    [42846 /* "Ꝟ" */, "V"],
    [581 /* "Ʌ" */, "V"],
    [42849 /* "ꝡ" */, "vy"],
    [42848 /* "Ꝡ" */, "VY"],
    [9446 /* "ⓦ" */, "w"],
    [65367 /* "ｗ" */, "w"],
    [7809 /* "ẁ" */, "w"],
    [7811 /* "ẃ" */, "w"],
    [373 /* "ŵ" */, "w"],
    [7815 /* "ẇ" */, "w"],
    [7813 /* "ẅ" */, "w"],
    [7832 /* "ẘ" */, "w"],
    [7817 /* "ẉ" */, "w"],
    [11379 /* "ⱳ" */, "w"],
    [9420 /* "Ⓦ" */, "W"],
    [65335 /* "Ｗ" */, "W"],
    [7808 /* "Ẁ" */, "W"],
    [7810 /* "Ẃ" */, "W"],
    [372 /* "Ŵ" */, "W"],
    [7814 /* "Ẇ" */, "W"],
    [7812 /* "Ẅ" */, "W"],
    [7816 /* "Ẉ" */, "W"],
    [11378 /* "Ⱳ" */, "W"],
    [9447 /* "ⓧ" */, "x"],
    [65368 /* "ｘ" */, "x"],
    [7819 /* "ẋ" */, "x"],
    [7821 /* "ẍ" */, "x"],
    [9421 /* "Ⓧ" */, "X"],
    [65336 /* "Ｘ" */, "X"],
    [7818 /* "Ẋ" */, "X"],
    [7820 /* "Ẍ" */, "X"],
    [9448 /* "ⓨ" */, "y"],
    [65369 /* "ｙ" */, "y"],
    [7923 /* "ỳ" */, "y"],
    [253 /* "ý" */, "y"],
    [375 /* "ŷ" */, "y"],
    [7929 /* "ỹ" */, "y"],
    [563 /* "ȳ" */, "y"],
    [7823 /* "ẏ" */, "y"],
    [255 /* "ÿ" */, "y"],
    [7927 /* "ỷ" */, "y"],
    [7833 /* "ẙ" */, "y"],
    [7925 /* "ỵ" */, "y"],
    [436 /* "ƴ" */, "y"],
    [591 /* "ɏ" */, "y"],
    [7935 /* "ỿ" */, "y"],
    [9422 /* "Ⓨ" */, "Y"],
    [65337 /* "Ｙ" */, "Y"],
    [7922 /* "Ỳ" */, "Y"],
    [221 /* "Ý" */, "Y"],
    [374 /* "Ŷ" */, "Y"],
    [7928 /* "Ỹ" */, "Y"],
    [562 /* "Ȳ" */, "Y"],
    [7822 /* "Ẏ" */, "Y"],
    [376 /* "Ÿ" */, "Y"],
    [7926 /* "Ỷ" */, "Y"],
    [7924 /* "Ỵ" */, "Y"],
    [435 /* "Ƴ" */, "Y"],
    [590 /* "Ɏ" */, "Y"],
    [7934 /* "Ỿ" */, "Y"],
    [9449 /* "ⓩ" */, "z"],
    [65370 /* "ｚ" */, "z"],
    [378 /* "ź" */, "z"],
    [7825 /* "ẑ" */, "z"],
    [380 /* "ż" */, "z"],
    [382 /* "ž" */, "z"],
    [7827 /* "ẓ" */, "z"],
    [7829 /* "ẕ" */, "z"],
    [438 /* "ƶ" */, "z"],
    [549 /* "ȥ" */, "z"],
    [576 /* "ɀ" */, "z"],
    [11372 /* "ⱬ" */, "z"],
    [42851 /* "ꝣ" */, "z"],
    [9423 /* "Ⓩ" */, "Z"],
    [65338 /* "Ｚ" */, "Z"],
    [377 /* "Ź" */, "Z"],
    [7824 /* "Ẑ" */, "Z"],
    [379 /* "Ż" */, "Z"],
    [381 /* "Ž" */, "Z"],
    [7826 /* "Ẓ" */, "Z"],
    [7828 /* "Ẕ" */, "Z"],
    [437 /* "Ƶ" */, "Z"],
    [548 /* "Ȥ" */, "Z"],
    [11391 /* "Ɀ" */, "Z"],
    [11371 /* "Ⱬ" */, "Z"],
    [42850 /* "Ꝣ" */, "Z"],
]);

/**
 * Replace diacritical or compatibility code points with their ASCII fallbacks.
 *
 * @param value raw user-provided text that may contain diacritics
 * @returns either the original string (when no replacements were needed) or a lazily built string with substitutions
 */
export const replaceDiacritics = (value: string): string => {
    // fast path: nothing to do for empty strings.
    if (value.length === 0) {
        return value;
    }

    // stays undefined until a replacement is necessary to avoid needless allocations
    let result: string | undefined;
    let lastCopiedIndex = 0;

    // iterate over each Unicode code point to correctly handle surrogate pairs
    for (let index = 0; index < value.length; ) {
        const firstCodePoint = value.codePointAt(index)!;
        const firstWidth = firstCodePoint > 0xffff ? 2 : 1;
        const singleReplacement = CODE_POINT_REPLACEMENTS.get(firstCodePoint);

        if (singleReplacement !== undefined) {
            // lazily initialize `result` with the untouched prefix once the first replacement is detected
            if (result === undefined) {
                result = value.slice(0, index);
            } else if (lastCopiedIndex < index) {
                result += value.slice(lastCopiedIndex, index);
            }

            // append the ASCII replacement and advance the copy cursor beyond the consumed code point
            result += singleReplacement;
            lastCopiedIndex = index + firstWidth;
            index += firstWidth;

            continue;
        }

        index += firstWidth;
    }

    // if no replacements were ever made, return the original string as-is
    if (result === undefined) {
        return value;
    }

    // copy any untouched tail that follows the final replacement
    if (lastCopiedIndex < value.length) {
        result += value.slice(lastCopiedIndex);
    }

    return result;
};
